import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import ReactWhatsapp from "react-whatsapp";

import Header from "../inc/Header";


import khapnecklace13_160gm from "../images/khap 13.160gm.jpg";
import khapnecklace14_530gm from "../images/khap 14.530gm.jpg";
import khapnecklace15_410gm from "../images/khap 15.410gm.jpg";
import khapnecklace15_900gm from "../images/khap 15.900gm.jpg";

import khapnecklace18_910gm from "../images/khap 18.910gm.jpg";
import KhapNecklace17_520gm from "../images/khap necklace17520gm.jpg";
import khapnecklace19_180gm from "../images/khap 19.180gm.jpg";
import khapnecklace20_850gm from "../images/Khap 20.850gm.jpg"


import khapnecklace20_770gm from "../images/khap Necklace 16.770gm.jpg";
import khapnecklace19_180gmnew from "../images/khap necklace 20.820gm.jpg";
import khapnecklace21_280gm from "../images/khap necklace 21.280.jpg";
import khapnecklace23_150gm from "../images/khap necklace 23.150gm.jpg";

import khapnecklace23_470gm from "../images/KHAP Necklace 23.470gm.jpg";
import khapnecklace23_620gm from "../images/KHAP Necklace 23.620.jpg";
import khapnecklace24_460gm from "../images/khap necklace 24.460gm.jpg";
import khapnecklace20_440gm from "../images/khap20.440gm.jpg";


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'






function KhapNecklace() {
    return (
        <div>
            
            <Header />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="maroon" />
            <div className='colorbacklockt'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Khap Necklace</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

          
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={khapnecklace13_160gm} className="card-img-top" alt="khapnecklace13_160gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Khap Necklace </h5>
                                                <p className="card-text">Weight: 13.160gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace14_530gm} className="card-img-top" alt="khapnecklace14_530gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Khap Necklace</h5>
                                                <p className="card-text">Weight: 14.530gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace15_410gm} className="card-img-top" alt="khapnecklace15_410gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Khap Necklace</h5>
                                                <p className="card-text">Weight: 15.410gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace13_160gm} className="card-img-top" alt="khapnecklace15_840gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Khap Necklace                                    </h5>
                                                <p className="card-text">Weight: 13.160gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

             <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={khapnecklace15_900gm} className="card-img-top" alt="khapnecklace15_900gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Khap Necklace </h5>
                                                <p className="card-text">Weight: 15.900gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace18_910gm} className="card-img-top" alt="khapnecklace18_910gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Khap Necklace </h5>
                                                <p className="card-text">Weight: 18.910gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace19_180gm} className="card-img-top" alt="khapnecklace18_910gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Khap Necklace</h5>
                                                <p className="card-text">Weight: 19.180gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace20_850gm} className="card-img-top" alt="khapnecklace20_850gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Khap Necklace                                     </h5>
                                                <p className="card-text">Weight: 20.850gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

     <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={khapnecklace19_180gmnew} className="card-img-top" alt="khapnecklace19_180gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Khap Necklace </h5>
                                                <p className="card-text">Weight: 20.820gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace20_770gm} className="card-img-top" alt="khapnecklace60_770gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Khap Necklace </h5>
                                                <p className="card-text">Weight: 16.770gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                         <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace21_280gm} className="card-img-top" alt="Weight: 21.810gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Khap Necklace</h5>
                                                <p className="card-text">Weight: 21.810gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace23_150gm} className="card-img-top" alt="khapnecklace23_150gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Khap Necklace                                     </h5>
                                                <p className="card-text">Weight: 23.150gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>




     <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={khapnecklace23_470gm} className="card-img-top" alt="khapnecklace23_470gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Khap Necklace </h5>
                                                <p className="card-text">Weight: 23.470gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace23_620gm} className="card-img-top" alt="khapnecklace23_620gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Khap Necklace </h5>
                                                <p className="card-text">Weight: 23.620gm</p>
                                                <p className="card-text">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                         <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace24_460gm} className="card-img-top" alt="khapnecklace24_460gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Khap Necklace</h5>
                                                <p className="card-text">Weight: 24.460gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={khapnecklace20_440gm} className="card-img-top" alt="khapnecklace20_440gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Khap Necklace                                     </h5>
                                                <p className="card-text">Weight: 20.440gm</p>
                                                <p className="card-text">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            

        
            <br />

            <br />
        </div>
    )
}

export default KhapNecklace